import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ZephyrLogo } from '../icons/zephyr-logo';
import { useEnvironment } from '../contexts';
export var PaperBox = function PaperBox(param) {
    var children = param.children, footer = param.footer;
    var environment = useEnvironment().environment;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col items-center justify-center w-full max-w-[780px] p-8 rounded-[16px] bg-[rgb(20,20,20)] text-white transition-shadow duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center w-full gap-4",
                children: [
                    /*#__PURE__*/ _jsx("a", {
                        href: environment.dashboardUrl,
                        children: /*#__PURE__*/ _jsx(ZephyrLogo, {})
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "border-b border-[var(--color-border-gray)] w-full"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-full",
                children: children
            }),
            footer && /*#__PURE__*/ _jsx("div", {
                className: "w-full mt-6",
                children: footer
            })
        ]
    });
};
